import utils from './utils.js'
export default {
  async fetchTollStationTreeNode (isAll) {
    let result = []
    await this.api('common/getOrganizationNodeByUser', {}).then(response => {
      if (response.data.code === '0') {
        let all = []
        if (!(isAll === false)) {
          all = [
            // {
            //   id: undefined,
            //   pid: undefined,
            //   label: '全部',
            //   type: undefined
            // }
          ]
        }
        let stations = utils.toTreeJson({
          data: response.data || [],
          idKey: 'organizationId',
          pidKey: 'parentId',
          parentNode: null
        })
        let company = []
        utils.filterCompany(stations, company)
        // result = [...all, ...stations]
        result = {stations: [...all, ...stations], company: company}
      }
    })
    return result
  }
}
